import { Form, Field } from "react-final-form";
import SimpleControlDialog from "../../components/SimpleControlDialog";
import Enums from "../../utils/Enums";
import {
  Typography,
  Box,

} from '@mui/material';
import { renderTextField } from '../../components/CustomReduxFormComponent';
const typographyRootStyle = {
  color: "red",
  whiteSpace: "pre-line",
  textAlign: "center",
  margin: 0,
  fontFamily: "Pru Sans,Roboto,Helvetica,Arial,sans-serif",
  fontWeight: 400,
  fontSize: "0.75rem",
  lineHeight: "1.66"
};
const required = value => (value ? undefined : "Required");

const TotpDialog = ({ open, closeHandler, submitHandler, switchToEmailOtpHandler, submitError, submitErrorMessage }) => {

  const handleSubmit = ({ otp }) => {
    if (otp) {
      submitHandler(otp.trim(), Enums.OTP_TYPE.TOTP);
    }
  };
  return (
    <>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, form, valid }) => {
          return (
            <>
              <SimpleControlDialog
                title="Verify One Time Password"
                show={open}
                onClose={closeHandler}
                valid={valid}
                onSubmit={handleSubmit}
                description={
                  <Typography variant="body2" sx={{ color: '#333333', fontWeight: 400, marginBottom: 2 }}>
                    Enter the code generated from your authenticator app
                  </Typography>
                }
                closeButtonDisplay={false}
                showCloseButton={true}
                okButtonText="Verify"
                footerContent={
                  (
                    <Box display="flex" justifyContent="center" alignItems="center">
                      <Typography variant="body2" sx={{ color: 'black', fontWeight: 400 }}>
                        Having trouble?&nbsp;
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{ color: 'black', textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={switchToEmailOtpHandler}
                      >
                        Switch to Email OTP
                      </Typography>
                    </Box>
                  )
                }
              >
                <Field
                  name="otp"
                  autoFocus
                  margin="dense"
                  component={renderTextField}
                  autoComplete="[off]"
                  label="OTP"
                  type="text"
                  validate={required}
                />
                {submitError && (
                  <div variant="caption" style={typographyRootStyle}>
                    {submitErrorMessage}
                  </div>
                )}

              </SimpleControlDialog>
            </>
          );
        }
        }
      />
    </>

  );
};
export default TotpDialog;